import Modifier from "../Modifier";

class MovingAverageModifier extends Modifier {

    constructor(parameters) {
        super(parameters);
        this.name = 'mvag';
        this.span = parameters.span;
        this.direction = parameters.direction;
    }

    compute(data, periodicity) {

        if (data.length < this.span) {
            return [];
        }

        let queue = this.initQueue(data);
        let modifier = this.getModifier();

        return data.map(function (kv, key) {

            if (data.length > (modifier + key)) {
                queue.push(data[key + modifier].value);
            }

            queue.shift();

            const filter = queue.filter(function (item) {
                return item !== null;
            });

            if (filter.length > 0) {
                kv.value = _.sum(filter) / filter.length;
                return kv;
            }

            kv.value = null;
            return kv;
        });
    }

    getModifier() {
        if (this.direction === 'left') {
            return this.span - 1;
        }
        if (this.direction === 'right') {
            return 0;
        }

        return Math.floor(this.span / 2);
    }

    initQueue(data) {

        let queue = [];

        if (this.direction === 'left') {
            let modifier = this.span - 1;
            queue.push(null);
            for (let i = 0; i < modifier; i++) {
                queue.push(data[i].value);
            }
            return queue;
        }

        if (this.direction === 'right') {
            for (let i = 0; i < this.span; i++) {
                queue.push(null);
            }
            return queue;
        }

        const half = Math.floor(this.span / 2);
        for (let i = 0; i < Math.ceil(this.span / 2); i++) {
            queue.push(null);
        }
        for (let i = 0; i < half; i++) {
            queue.push(data[i].value);
        }
        return queue;

    }
}

export default MovingAverageModifier;
